<template>
    <form @submit.prevent="proceed" @keydown="cycleForm.errors.clear($event.target.name)">
        <div class="row">
            <div class="col-12 col-sm-12">
                <div class="form-group">
                    <label for="">Name</label>
                    <input class="form-control" :class="{ 'is-invalid': cycleForm.errors.has('name') }" type="text" value="" v-model="cycleForm.name" name="name" placeholder="Name">
                    <show-error :form-name="cycleForm" prop-name="name"></show-error>
                </div>
            </div>
        </div>
        <button type="submit" class="btn btn-primary mr-1 mb-1 waves-effect waves-light pull-right">
            <span v-if="id">{{trans('general.update')}}</span>
            <span v-else>{{trans('general.save')}}</span>
        </button>
        <router-link to="/cycle" class="btn btn-danger waves-effect waves-light pull-right mr-1 mb-1" v-show="id">{{trans('general.cancel')}}</router-link>
        <button v-if="!id" type="button" class="btn btn-danger waves-effect waves-light pull-right mr-1 mb-1" @click="$emit('cancel')">{{trans('general.cancel')}}</button>
    </form>
</template>


<script>
    export default {
        data() {
            return {
                cycleForm: new Form({
                    name : ''
                })
            };
        },
        props: ['id'],
        mounted() {
            if(this.id)
                this.getCycle();
        },
        methods: {
            proceed(){
                if(this.id)
                    this.updateCycle();
                else
                    this.storeCycle();
            },
            storeCycle(){
                this.cycleForm.post('/api/setting/cycle')
                    .then(response => {
                        toastr.success(response.message);
                        this.$emit('completed')
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            },
            getCycle(){
                axios.get('/api/setting/cycle/'+this.id)
                    .then(response => response.data)
                    .then(response => {
                        this.cycleForm.name = response.name;
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                        this.$router.push('/setting/cycle');
                    });
            },
            updateCycle(){
                this.cycleForm.patch('/api/setting/cycle/'+this.id)
                    .then(response => {
                        toastr.success(response.message);
                        this.$router.push('/setting/cycle');
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            }
        }
    }
</script>
